import { useEffect, useState } from 'react';
import {NavMenu, Button, Loading, Pagination} from '../../components';
import { DisplayUtils } from '../../utils';
import { useTranslation } from 'react-i18next';
import { useParametrics } from '../../contexts/ParametricsContext';
import { usePetition } from "../../contexts/PetitionContext";
import './Notifications.scss';
import {getNotificationDetailAndRead, getNotifications} from "../../services/notificationServices";

const Notifications = () => {
    const { t } = useTranslation();
    const [generalNotifications, setGeneralNotifications] = useState();
    const [requestNotifications, setRequestNotifications] = useState();
    const [notificationDetail, setNotificationDetail] = useState();
    const { convocationId } = useParametrics();
    const { petitionId } = usePetition();
    const [loading, setLoading] = useState(true);

    const [view, setView] = useState(0);

    const [generalPage, setGeneralPage] = useState(0);
    const [requestPage, setRequestPage] = useState(0);
    const [generalTotalPages, setGeneralTotalPages] = useState(0);
    const [requestTotalPages, setRequestTotalPages] = useState(0);
    const pageSize = 10;

    useEffect(() => {
        if (!convocationId || !petitionId) return;
        loadNotifications("GENERALES");
        loadNotifications("SOLICITUD");
    }, [convocationId, petitionId])

    useEffect(() => {
        loadNotifications("GENERALES")
    }, [generalPage]);

    useEffect(() => {
        loadNotifications("SOLICITUD")
    }, [requestPage]);

    const getColors = (item) => {
        if (item === view) {
            return {
                backgroundColor: DisplayUtils.isMobile() ? '#829bba' : '#34fdfe',
                color: DisplayUtils.isMobile() ? '#ffffff' : '#35316a',
            };
        }
    };

    const formatDate = (input) => {
        const date = new Date(input);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const notificationItem = (data, index) => {
        return (
            <button
                type="button"
                className={"Notifications__content__list__item" + (data?.read ? "" : " item__badge")}
                key={index}
                onClick={() => loadNotificationDetail(data?.id)}
                aria-label={`${t('Globals.seeCompany')} ${data?.title}`}
            >
                <div className="Notifications__content__list__item__right">
                    <h2 className="Notifications__content__list__item__right__name">
                        {data?.title || "-"}
                    </h2>
                    <p className="Notifications__content__list__item__right__types d-block" key={index}>
                        {data?.creationTime ? formatDate(data.creationTime) : "-"}
                    </p>
                </div>
                <div className="Notifications__content__list__item__left">
                    <div className="Notifications__content__list__item__left__image">
                        <img alt=' ' src={data?.image || 'misc/icons/logo-bono.png'} />
                    </div>
                </div>
            </button>
        )
    }

    const details = () => (
        <div className="Notifications__content__notificationDetail">
            <div className="Notifications__content__notificationDetail__container">
                <div className="Notifications__content__notificationDetail__container__button-back-container">
                    <button
                        type="button"
                        className="Notifications__content__notificationDetail__container__button-back-container__button-back"
                        onClick={() => {
                            loadNotifications(getNotificationsType())
                            setNotificationDetail()
                        }}
                    >
                        <span className="sr-only">{t('Globals.return')}</span>
                        <img src="/misc/icons/arrow-left-pink.svg" alt=" " />
                    </button>
                </div>
                <div className="Notifications__content__notificationDetail__container__content-container">
                    <div className="Notifications__content__notificationDetail__container__content-container__image-container">
                        <div className="Notifications__content__notificationDetail__container__content-container__image-container__image">
                            <img alt='icon' src='misc/icons/logo-bono.png' />
                        </div>
                    </div>
                    <h1 className="Notifications__content__notificationDetail__container__content-container__title">
                        {notificationDetail?.title}
                    </h1>
                    {notificationDetail?.notificationCategory && (
                        <p className="Notifications__content__notificationDetail__container__content-container__category">
                            {getNotificationTypeTitle()}
                        </p>
                    )}
                    {notificationDetail?.creationTime && (
                        <p className="Notifications__content__notificationDetail__container__content-container__date">
                            {formatDate(notificationDetail?.creationTime)}
                        </p>
                    )}
                    {notificationDetail?.body && (
                        <p className="Notifications__content__notificationDetail__container__content-container__body">
                            {notificationDetail?.body}
                        </p>
                    )}
                </div>
            </div>
        </div>
    )

    function getActiveNotifications() {
        if (view === 0) {
            return generalNotifications
        } else {
            return requestNotifications
        }
    }

    const loadNotifications = async (category) => {
        try {
            setLoading(true);
            const searchParams = new URLSearchParams()
            if (category === "GENERALES") {
                searchParams.append('page', generalPage + 1);
                searchParams.append('size', pageSize);
                searchParams.append('notificationCategory', category);
                const response = await getNotifications(
                    convocationId, petitionId, searchParams
                );
                setGeneralTotalPages(response.totalPages)
                setGeneralNotifications(response.content)
            } else {
                searchParams.append('page', requestPage + 1);
                searchParams.append('size', pageSize);
                searchParams.append('notificationCategory', category);
                const response = await getNotifications(
                    convocationId, petitionId, searchParams
                );
                setRequestTotalPages(response.totalPages)
                setRequestNotifications(response.content)
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const loadNotificationDetail = async (id) => {
        try {
            setLoading(true);
            const response = await getNotificationDetailAndRead(
                convocationId, petitionId, id
            );
            setNotificationDetail(response)
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    function getNotificationsType() {
        if(view === 0)
            return "GENERALES"
        else
            return "SOLICITUD"
    }

    function getButtonBadgeClass(view) {
        if (view === 0) {
            if(generalNotifications?.filter(n => n.read === false).length > 0) {
                return " item__badge"
            } else {
                return ""
            }
        } else {
            if(requestNotifications?.filter(n => n.read === false).length > 0) {
                return " item__badge"
            } else {
                return ""
            }
        }

    }

    function getNotificationTypeTitle() {
        if (view === 0) {
            return t('Notifications.generals');
        } else {
            return t('Notifications.request');
        }
    }

    return (
        <NavMenu>
            <div className="Notifications">
                <div className="Notifications__content">
                    { notificationDetail ? (
                        details()
                    ): (
                        loading ? (
                            <div className='vh-100 d-flex justify-content-center align-items-center'>
                                <Loading />
                            </div>
                        ) : (
                            <>
                                <div className="w-100 d-flex justify-content-center">
                                    <div className="Notifications__content__title">
                                        <h1>{t('Notifications.title')}</h1>
                                    </div>
                                </div>
                                <div className="w-100 d-flex justify-content-center">
                                    <div className="Notifications__content__box">
                                        <div className="Notifications__content__box__buttons">
                                            <div className={'Notifications__content__box__buttons__button' + getButtonBadgeClass(0) }>
                                                <Button
                                                    className="buttonNotifications"
                                                    text={t('Notifications.generals')}
                                                    action={() => {
                                                        setView(0)
                                                        loadNotifications("GENERALES")
                                                    }}
                                                    styles={getColors(0)}
                                                />
                                            </div>
                                            <div className={'Notifications__content__box__buttons__button' + getButtonBadgeClass(1) }>
                                                <Button
                                                    className="buttonNotifications "
                                                    text={t('Notifications.request')}
                                                    action={() => {
                                                        setView(1)
                                                        loadNotifications("SOLICITUD")
                                                    }}
                                                    styles={getColors(1)}
                                                />
                                            </div>
                                        </div>
                                        {getActiveNotifications()?.length > 0 ? (
                                            getActiveNotifications()?.map((item, index) => (
                                                notificationItem(item, index)
                                            ))
                                        ): (
                                            <p className='Notifications__content__list__empty'>No hay avisos</p>
                                        )}
                                    </div>
                                </div>
                                { ((view === 0 && generalTotalPages > 1) ||
                                    (view === 1 && requestTotalPages > 1)) && (
                                    <Pagination
                                        page={view === 0 ? generalPage : requestPage}
                                        totalPages={view === 0 ? generalTotalPages : requestTotalPages}
                                        onPageChange={(selected) => {
                                            if (view === 0) {
                                                setGeneralPage(selected)
                                            } else {
                                                setRequestPage(selected)
                                            }
                                        }}
                                    />
                                )}
                            </>
                        ))}
                </div>
            </div>
        </NavMenu>
    )
}

export default Notifications;
